import React, { useMemo } from 'react';

import TabSwitcher from '@/components/Tabs/Tabs';
import { ExploreBlockType } from '@addmile/backend-client';

import BlockList from './BlockList/BlockList';
import CollectionsList from './CollectionsList/CollectionsList';
import CreateCollectionHeader from './CreateCollectionHeader/CreateCollectionHeader';

interface ContentListViewProps {
  onCreateCollection: () => void;
  onCreateBlock: (type: ExploreBlockType) => void;
  onEditBlock: (slug: string) => void;
  onEditCollection: (slug: string) => void;
  onViewCollectionBlocks: (slug: string) => void;
  onDeleteCollection: (slug: string) => void;
  onDeleteBlock: (slug: string) => void;
  onCopyBlock: (slug: string) => void;
}

export const ContentListView: React.FC<ContentListViewProps> = ({
  onCreateCollection,
  onCreateBlock,
  onEditBlock,
  onEditCollection,
  onViewCollectionBlocks,
  onDeleteCollection,
  onDeleteBlock,
  onCopyBlock,
}) => {
  const tabKeys = useMemo(
    () => [
      {
        label: 'Collections',
        key: 'collections',
      },
      { label: 'Content', key: 'content' },
    ],
    [],
  );

  return (
    <div className="max-w-[1084px] p-6 rounded-2xl">
      <div className="mb-6 space-y-6">
        <CreateCollectionHeader
          onCreateCollection={onCreateCollection}
          onCreateBlock={onCreateBlock}
        />
        <TabSwitcher
          tabKeys={tabKeys}
          className="border-b border-neutral-20 gap-12"
          tabs={{
            collections: (
              <CollectionsList
                onEdit={onEditCollection}
                onDelete={onDeleteCollection}
                onViewBlocks={onViewCollectionBlocks}
              />
            ),
            content: (
              <div className="space-y-4">
                <BlockList
                  onEditBlock={onEditBlock}
                  onDeleteBlock={onDeleteBlock}
                  onCopyBlock={onCopyBlock}
                />
              </div>
            ),
          }}
        />
      </div>
    </div>
  );
};

export default ContentListView;
